<template>
  <section class="section-content product-process">
    <div class="section-title">
      <h3 class="title">理赔流程</h3>
    </div>
    <div class="section-main">
      <!-- <div class="process-tabnav">
        <a
          href="javascript:;"
          @click="tabChange(1)"
          class="btn"
          :class="{ active: activeIndex == 1 }"
          >投保流程</a
        >
        <a
          href="javascript:;"
          @click="tabChange(2)"
          class="btn"
          :class="{ active: activeIndex == 2 }"
          >理赔流程</a
        >
      </div> -->
      <!-- <div class="process-inner" v-if="activeIndex == 1">
        <ol class="list">
          <li>
            <h4>填写表单</h4>
            <p>告知您的产品需求</p>
          </li>
          <li>
            <h4>了解产品</h4>
            <p>接听400-880-3633 客服电话</p>
          </li>
          <li>
            <h4>确认需求</h4>
            <p>人工电话为您投保</p>
          </li>
          <li>
            <h4>签收保单</h4>
            <p>投保成功保障生效</p>
          </li>
        </ol>
      </div> -->
      <div class="process-inner" >
        <ol class="list">
          <li>
            <h4>理赔报案</h4>
            <p>
              保险事故发生后10日内拨打客服热线95362报案并获取《索赔申请书》，并提供相关证明和资料原件
            </p>
          </li>
          <li>
            <h4>准备理赔资料</h4>
            <p>请您完整填写和亲笔签署《索赔申请书》</p>
          </li>
          <li>
            <h4>提交索赔申请</h4>
            <p>拨打客服热线95362提交索赔申请</p>
          </li>
          <li>
            <h4>理赔核定</h4>
            <p>我们收到您的索赔资料后将及时登记，并核实您的理赔资料</p>
          </li>
          <li>
            <h4>理赔给付</h4>
            <p>
              如果您的索赔申请经核定可以获得赔付，我们将会在3个工作日内把保险金汇入您指定的银行账户。
            </p>
          </li>
        </ol>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      activeIndex: 1,
    };
  },
  methods: {
    tabChange(index) {
      this.activeIndex = index;
    },
  },
};
</script>

<style scoped>
.section-content {
  margin-top: 0.1rem;
  background: #fff;
}
.section-title {
  padding: 0.15rem;
  border-bottom: 1px solid #eee;
}
.section-title .title {
  font-size: 0.16rem;
  color: #333;
  line-height: 0.2rem;
  font-weight: bold;
}
.process-tabnav {
  box-sizing: border-box;
  width: 2.1rem;
  height: 0.38rem;
  margin: 0.18rem auto;
  overflow: hidden;
  text-align: center;
  border: 1px solid #3aaaf8;
  border-radius: 0.19rem;
}
.process-tabnav .btn {
  display: block;
  float: left;
  width: 50%;
  font-size: 0.14rem;
  color: #3aaaf8;
  line-height: 0.38rem;
}
a:active {
  outline: 0;
  opacity: 0.85;
}
.process-tabnav .btn.active {
  background: #3aaaf8;
  color: #fff;
}
.process-inner {
  padding: 0 0.05rem 0.3rem 0.13rem;
}
.process-inner .list {
  position: relative;
  padding: 0.05rem 0;
  overflow: hidden;
}
.process-inner .list:before {
  display: block;
  content: "";
  position: absolute;
  left: 0.17rem;
  top: 0;
  width: 1px;
  height: 100%;
  border-left: 0.01rem dashed #ddd;
  z-index: 1;
}
.process-inner li {
  position: relative;
  padding-left: 0.5rem;
  margin-bottom: 0.12rem;
  font-size: 0.13rem;
}
.process-inner li:before {
  display: block;
  content: "";
  width: 0.36rem;
  height: 0.36rem;
  position: absolute;
  left: 0;
  top: -0.05rem;
  background: url(./process_number.png) no-repeat;
  background-size: 0.36rem 3.6rem;
  z-index: 2;
}
.process-inner li:nth-child(2):before {
  background-position: 0 -0.36rem;
}
.process-inner li:nth-child(3):before {
  background-position: 0 -72rem;
}
.process-inner li:nth-child(4):before {
  background-position: 0 -1.08rem;
}
.process-inner li:nth-child(5):before {
  background-position: 0 -1.44rem;
}
.process-inner li:nth-child(6):before {
  background-position: 0 -1.8rem;
}
.process-inner li:nth-child(7):before {
  background-position: 0 -2.16rem;
}
.process-inner li:nth-child(8):before {
  background-position: 0 -2.52rem;
}
.process-inner li:nth-child(9):before {
  background-position: 0 -2.88rem;
}
.process-inner li:nth-child(10):before {
  background-position: 0 -3.34rem;
}
.process-inner li:last-child:after {
  display: block;
  content: "";
  position: absolute;
  left: 0.15rem;
  top: 0.3rem;
  width: 0.05rem;
  height: 100%;
  background: #fff;
  z-index: 3;
}
.process-inner li h4 {
  color: #555;
  margin: 0;
  padding: 0;
  font-weight: normal;
  margin-bottom: 0.03rem;
}
.process-inner li p {
  color: #999;
}
</style>
